module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/personalize-events-2018-03-22.paginators.json
// module id = 691
// module chunks = 2